import {GroupMember} from '@/features/users/types'
import {create} from 'zustand'

export const useConfirmationDialogStore = create<{
    accordionType: 'no-action' | 'notification' | 'conversation'
    isAccordionOpen: boolean
    selectedMembers: (GroupMember & {type: 'user' | 'group'})[]
    setSelectedMembers: (members: (GroupMember & {type: 'user' | 'group'})[]) => void
    setAccordionType: (type: 'no-action' | 'notification' | 'conversation') => void
    setIsAccordionOpen: (open: boolean) => void
    resetStore: () => void
}>(set => ({
    accordionType: 'no-action',
    isAccordionOpen: false,
    selectedMembers: [],
    setSelectedMembers: (members: (GroupMember & {type: 'user' | 'group'})[]) => set({selectedMembers: members}),
    setAccordionType: (type: 'no-action' | 'notification' | 'conversation') => set({accordionType: type}),
    setIsAccordionOpen: open => set({isAccordionOpen: open}),
    resetStore: () =>
        set({
            accordionType: 'no-action',
            isAccordionOpen: false,
            selectedMembers: []
        })
}))
